module.exports = __webpack_public_path__ + "static/media/FullyFunded.8d3da6d8.png";